import { useMutation } from 'react-query';
import { useRouteParams } from '../hooks/useRouteParams';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { AgreementDTO } from './useAutoAccountAgreementsQuery';
import { queryClient } from '../../../../config/queryClient';
import { queryKeys } from './queryKeys';
import { toast } from '../../../CommonComponents/OPL/Toast/Toast';

const acceptAgreementRequest = (clientId: string, agreementId: string): Promise<AgreementDTO> => {
  return authFetch(
    urlWithParams('/Consumer/AutomatedAccountsUpdate/AcceptAgreement', {
      clientId,
      agreementId,
    }),
    { method: 'POST' },
  );
};

export const useAcceptAgreementMutation = () => {
  const { clientId } = useRouteParams();

  return useMutation((agreementId: string) => acceptAgreementRequest(clientId, agreementId), {
    onSuccess(updatedAgreement) {
      queryClient.setQueryData<AgreementDTO[]>(
        queryKeys.AutoAccountAgreement(clientId),
        (agreements = []) =>
          agreements.map(agreement =>
            agreement.id === updatedAgreement.id ? updatedAgreement : agreement,
          ),
      );
    },
    onError(error) {
      toast.error(error.message);
    },
  });
};
